import { getAPI } from './api';

interface PresignUploadResponse {
  path: string;
  presigned_url: string;
}

export const presignUpload = async (
  documentationId: string
): Promise<PresignUploadResponse> => {
  const { data } = await getAPI().get(
    `/admin/documentations/${documentationId}/presign_upload`
  );

  return data;
};

interface UpdateDocumentParams {
  documentationId: string;
  id: string;
  file_path: string;
  file_name: string;
  file_size: number;
}

export const updateDocument = async ({
  documentationId,
  id,
  file_path,
  file_name,
  file_size
}: UpdateDocumentParams): Promise<void> => {
  await getAPI().put(
    `/admin/documentations/${documentationId}/documents/${id}`,
    {
      file_path,
      file_name,
      file_size
    }
  );
};

interface CreateDocumentParams {
  template_id: string;
  documentationId: string;
  file_path: string;
  file_name: string;
  file_size: number;
}

export const createDocument = async ({
  template_id,
  documentationId,
  file_path,
  file_name,
  file_size
}: CreateDocumentParams): Promise<void> => {
  await getAPI().post(`/admin/documentations/${documentationId}/documents`, {
    template_id,
    file_path,
    file_name,
    file_size
  });
};
